/**
 * Размеры
 */
enum TirPmTagSizeEnum {
  /**
   * Средний
   * */
  Middle = "middle",
  /**
   * Маленький
   */
  Small = "small",
}
export default TirPmTagSizeEnum;
